let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gDPLv")).then(() => parcelRequire('jsrqy'));